import axios from '@/libs/api.request'

// console.trace('xxxxxxxxxxx2') 

// 枚举列表
export const getEnumListByCls = (data) => {
  let kuData = JSON.parse(sessionStorage.getItem('enumerationData')) || {}
  if (kuData.hasOwnProperty(`${data.enumClassName}`)) {
    // console.log(data.enumClassName,'存过值了',kuData[`${data.enumClassName}`])
    return new Promise((resolve, reject) => {
      let list = kuData[`${data.enumClassName}`]
      resolve({ data: { code: 0, data: list, mag: 'ok' } })
    })
  } else {
    // console.log('请求了接口数据')
    return axios.request({
      data: data,
      url: `/api/api/getEnumListByCls`,
      method: 'post',
      headers: {
        noEncryption: true
      }
    })
  }
}
// 枚举列表
export const getDictListByDicType = (data = {}) => {
  let otherData = { flag: true }
  Object.assign(data, otherData)
  let kuData = JSON.parse(sessionStorage.getItem('dictypeData')) || {}

  if (kuData.hasOwnProperty(`${data.typeCode}`)) {
    // console.log(data.enumClassName,'存过值了',kuData[`${data.enumClassName}`])
    return new Promise((resolve, reject) => {
      let list = kuData[`${data.typeCode}`]
      resolve({ data: { code: 0, data: list, mag: 'ok' } })
    })
  } else {
    // console.log('请求了接口数据')
    return axios.request({
      data: data,
      url: `/api/api/getDictListByDicType`,
      method: 'post',
      headers: {
        noEncryption: true
      }
    })
  }
}
